import { render } from "./BottomListTagsAndPhotosProp.vue?vue&type=template&id=3ebc0efd&scoped=true"
import script from "./BottomListTagsAndPhotosProp.vue?vue&type=script&lang=js"
export * from "./BottomListTagsAndPhotosProp.vue?vue&type=script&lang=js"

import "./BottomListTagsAndPhotosProp.vue?vue&type=style&index=0&id=3ebc0efd&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebc0efd"]])

export default __exports__